export const LoadingScreen = () => {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <span className="loading loading-ball loading-lg bg-zinc-900"></span>
    </div>
  );
};
